module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('h2', [_vm._v("Contents")]), _vm._v(" "), _c('ol', {
    staticClass: "bbb-rw",
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/Text/cover"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s001BookTitlePage01"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s002Copyright01"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s004Chapter001"
    }
  }, [_vm._v("Chapter One")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s005Chapter002"
    }
  }, [_vm._v("Chapter Two")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s006Chapter003"
    }
  }, [_vm._v("Chapter Three")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s007Chapter004"
    }
  }, [_vm._v("Chapter Four")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s008Chapter005"
    }
  }, [_vm._v("Chapter Five")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s009Chapter006"
    }
  }, [_vm._v("Chapter Six")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s016Appendix01"
    }
  }, [_vm._v("Discover More Grace Burrowes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s012AboutTheAuthor01"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s013AdCard01"
    }
  }, [_vm._v("Also by Grace Burrowes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s014FrontSales01"
    }
  }, [_vm._v("High Acclaim for Grace Burrowes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Text/s015BackAd01"
    }
  }, [_vm._v("Do you love Grace Burrowes? Don’t miss these books!")])])])]), _vm._v(" "), _c('nav', {
    staticClass: "ccc-rw",
    attrs: {
      "epub:type": "landmarks"
    }
  }, [_c('h2', [_vm._v("\n    Navigation\n   ")]), _vm._v(" "), _c('ol', {
    attrs: {
      "epub:type": "list"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/Text/TOC"
    }
  }, [_vm._v("\n      Table of Contents\n     ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea93f88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 66
// module chunks = 0